import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
    header {
        height: auto;
        padding-inline: 0;
    }
`;
